/* eslint-disable */

export const SET_LOADING = 'SET_LOADING';
export const SET_RECORDING = 'SET_RECORDING';
